import { observer } from 'mobx-react';
import { theme } from 'antd';

import { useStores } from '@/hooks/use-stores';
import DessicantAirDryerMaintenanceWidget from '@/comp/common/icons/DessicantAirDryerMaintenanceWidget';
import DessicantAirDryerWidget from '@/comp/common/icons/DessicantAirDryerWidget';

import { getWidgetFillColor, isSelectedNodeOnMap } from '../../utils/utils';
import { Container } from './DesiccantAirDryerNodeWidget.styles';
import { DesiccantMapView } from './DessicantMapView/DesiccantMapView';
import { DessicantDetailsView } from './DessicantDetailsView/DessicantDetailsView';
import { getBorderInfo } from '../compressor/CompressorNodeWidget.utils';
import { DUMMY_MODEL_IDS } from '../nodeWidget/EditAssetDrawer/EditAssetDrawer.utils';

const { useToken } = theme;

export const DesiccantAirDryerNodeWidget = observer(
  ({ node, engine, width, height }: { node; width; height; engine? }) => {
    const { mapBuilderStore } = useStores();
    const { token } = useToken();
    const { deviceId, inMaintenance, deviceModelId } = node.getEntity();

    const renderedOnMap = !!engine;
    const isSelected = isSelectedNodeOnMap(deviceId, mapBuilderStore.selectedDevice?.deviceId, renderedOnMap);
    const backgroundColor = getWidgetFillColor(isSelected, token, renderedOnMap);
    const hasNoMatchingSpec = deviceModelId === DUMMY_MODEL_IDS.desiccantAirDryer && renderedOnMap;
    const borderInfo = getBorderInfo(isSelected, inMaintenance, false, hasNoMatchingSpec, token);

    return (
      <Container width={width} height={height} $mapView={engine ? -1 : 1}>
        {borderInfo ? (
          <DessicantAirDryerMaintenanceWidget
            width={width}
            height={height}
            color={backgroundColor}
            fillColor={borderInfo.fillColor}
            borderColor={borderInfo.borderColor}
            className="background dessicant-dryer-maintenance"
          />
        ) : (
          <DessicantAirDryerWidget width={width} height={height} color={backgroundColor} className="background" />
        )}
        {renderedOnMap ? (
          <DesiccantMapView node={node} engine={engine} height={height} width={width} borderInfo={borderInfo} />
        ) : (
          <DessicantDetailsView node={node} />
        )}
      </Container>
    );
  },
);
